<div class="sp-bg">
  <div class="sp-card">
    <header class="sp-header">
      <div class="sp-title">
        <img src="assets/novax-logo.svg" class="sp-logo" alt="Logo" />
        <h1>Formulario de postulación</h1>
      </div>

      <p *ngIf="!loading && valido && !enviado">
        Completa la siguiente información para registrar tu perfil como
        prospecto. La información será utilizada únicamente para procesos de
        preselección.
      </p>
    </header>

    <!-- Estados -->
    <div *ngIf="loading" class="sp-info">Validando enlace…</div>

    <div *ngIf="!loading && !valido" class="sp-error">
      <h3>Enlace no válido</h3>
      <p>{{ mensajeError }}</p>
    </div>

    <div *ngIf="!loading && enviado_again && !enviado" class="sp-error">
      <p>{{ mensajeError }}</p>
    </div>

    <!--     Mensaje éxito (oculta el form) -->
    <div *ngIf="!loading && valido && enviado" class="sp-success">
      <h3>Formulario enviado</h3>
      <p>{{ mensajeExito }}</p>
    </div>

    <div class="sp-steps-wrapper" *ngIf="!loading && valido && !enviado">
      <div class="sp-steps">
        <div
          class="sp-step"
          *ngFor="let step of steps; let i = index"
          [class.active]="i === currentStep"
          [class.completed]="isStepCompleted(i)"
          [class.clickable]="isStepAccessible(i)"
          (click)="goToStep(i)"
        >
          <div class="sp-step-circle">
            <span *ngIf="isStepCompleted(i)">✓</span>
            <span *ngIf="!isStepCompleted(i)">{{ i + 1 }}</span>
          </div>
          <div class="sp-step-label">{{ step.label }}</div>
        </div>
      </div>

      <div class="sp-progress-bar">
        <div
          class="sp-progress-value"
          [style.width.%]="progressPercentage"
        ></div>
      </div>
    </div>
    <form
      *ngIf="!loading && valido && !enviado"
      [formGroup]="form"
      (ngSubmit)="enviar()"
      class="sp-form"
    >
      <div
        class="sp-policy-gate"
        *ngIf="currentStep === 0 && privacyGateRequired"
        [class.sp-policy-gate--accepted]="canUseRecruitmentForm"
      >
        <div class="sp-policy-gate__header">
          <div>
            <span>Tratamiento de datos personales para reclutamiento</span>
          </div>

          <button
            type="button"
            class="sp-policy-link"
            (click)="openPrivacyPolicyDocument()"
            [disabled]="privacyPdfLoading"
          >
            {{
              privacyPdfLoading
                ? "Cargando documento..."
                : "Ver tratamiento de datos"
            }}
          </button>
        </div>

        <p>
          {{ companyName }} recopilará y tratará tus datos personales, hoja de
          vida, formación académica, experiencia laboral, referencias y
          documentos cargados únicamente para gestionar tu postulación, evaluar
          tu perfil, contactarte y continuar el proceso de selección.
        </p>

        <p>
          Tus datos serán conservados durante el proceso de reclutamiento y, si
          autorizas, podrán mantenerse para futuras vacantes por un periodo
          determinado. {{ companyName }} aplicará medidas de seguridad para
          proteger tu información. Puedes solicitar acceso, rectificación,
          actualización, eliminación u oposición al tratamiento escribiendo a:
          <strong>{{ "talento.humano@novax.ec" }}</strong
          >.
        </p>

        <div class="sp-policy-checks">
          <label class="sp-policy-check">
            <input
              type="checkbox"
              [(ngModel)]="privacyAccepted"
              name="privacyAccepted"
              [ngModelOptions]="{ standalone: true }"
              (change)="onPrivacyCheckChange()"
            />
            <span>
              He leído y acepto la Política de Tratamiento de Datos Personales
              de
              {{ companyName }} y autorizo el tratamiento de mis datos
              personales exclusivamente para fines de reclutamiento, evaluación,
              comunicación y selección de personal.
            </span>
          </label>

          <label class="sp-policy-check">
            <input
              type="checkbox"
              [(ngModel)]="privacyContactAccepted"
              name="privacyContactAccepted"
              [ngModelOptions]="{ standalone: true }"
              (change)="onPrivacyCheckChange()"
            />
            <span>
              Autorizo que {{ companyName }} me contacte por correo electrónico,
              llamada telefónica o WhatsApp para asuntos relacionados con mi
              postulación.
            </span>
          </label>

          <label class="sp-policy-check">
            <input
              type="checkbox"
              [(ngModel)]="privacyTruthAccepted"
              name="privacyTruthAccepted"
              [ngModelOptions]="{ standalone: true }"
              (change)="onPrivacyCheckChange()"
            />
            <span>
              Declaro que la información ingresada es verdadera y autorizo a
              {{ companyName }} a verificar los datos laborales, académicos y
              referencias proporcionadas dentro del proceso de selección.
            </span>
          </label>
        </div>

        <div class="sp-policy-status" *ngIf="!canUseRecruitmentForm">
          Debe aceptar las autorizaciones para desbloquear el formulario.
        </div>

        <div
          class="sp-policy-status sp-policy-status--ok"
          *ngIf="canUseRecruitmentForm"
        >
          Autorizaciones aceptadas. Puede continuar con la postulación.
        </div>
      </div>
      <div class="sp-field sp-readonly-highlight">
        <label>Cargo al que postula</label>
        <input
          type="text"
          disabled="true"
          [value]="tokenResult?.role_required?.nombre"
        />
      </div>
      <section class="sp-step-panel" *ngIf="currentStep === 0">
        <h4 class="sp-section-title">Identificación</h4>

        <div class="sp-grid">
          <div
            class="sp-field"
            [ngClass]="{
              invalid: isInvalid('id_card'),
              valid: form.get('id_card')?.valid,
            }"
          >
            <label>🪪 Cédula de Identidad <span class="req">*</span></label>
            <input
              type="text"
              formControlName="id_card"
              placeholder="Escribe tu cédula"
              inputmode="numeric"
              maxlength="10"
              (input)="soloNumeros($event)"
            />
            <div *ngIf="isInvalid('id_card')" class="sp-error-message">
              <small *ngIf="form.get('id_card')?.errors?.['required']">
                La cédula es obligatoria.
              </small>
              <small *ngIf="form.get('id_card')?.errors?.['cedulaInvalida']">
                {{ form.get("id_card")?.errors?.["cedulaInvalida"] }}
              </small>
            </div>
          </div>

          <div
            class="sp-field"
            [ngClass]="{
              invalid: form.get('name')?.invalid && form.get('name')?.touched,
              valid: form.get('name')?.valid,
            }"
          >
            <label>Nombres completos <span class="req">*</span></label>
            <input
              type="text"
              formControlName="name"
              placeholder="Escribe tus nombres"
              (input)="transformInput($event, 'name', true, true)"
            />
            <div
              *ngIf="form.get('name')?.invalid && form.get('name')?.touched"
              class="sp-error-message"
            >
              <small *ngIf="form.get('name')?.errors?.['required']">
                Campo requerido.
              </small>
            </div>
          </div>

          <div
            class="sp-field"
            [ngClass]="{
              invalid: isInvalid('father_surname'),
              valid: form.get('father_surname')?.valid,
            }"
          >
            <label>Apellido Paterno <span class="req">*</span></label>
            <input
              type="text"
              formControlName="father_surname"
              placeholder="Ingrese apellido paterno"
              (input)="transformInput($event, 'father_surname', false, true)"
            />
            <div *ngIf="isInvalid('father_surname')" class="sp-error-message">
              <small>Campo requerido.</small>
            </div>
          </div>

          <div
            class="sp-field"
            [ngClass]="{
              invalid: isInvalid('mother_surname'),
              valid: form.get('mother_surname')?.valid,
            }"
          >
            <label>Apellido Materno <span class="req">*</span></label>
            <input
              type="text"
              formControlName="mother_surname"
              placeholder="Ingrese apellido materno"
              (input)="transformInput($event, 'mother_surname', false, true)"
            />
            <div *ngIf="isInvalid('mother_surname')" class="sp-error-message">
              <small>Campo requerido.</small>
            </div>
          </div>
        </div>
      </section>
      <section class="sp-step-panel" *ngIf="currentStep === 1">
        <h4 class="sp-section-title">Información personal</h4>

        <div class="sp-grid">
          <div
            class="sp-field"
            [ngClass]="{
              invalid:
                form.get('birth_date')?.invalid &&
                form.get('birth_date')?.touched,
              valid: form.get('birth_date')?.valid,
            }"
          >
            <label>Fecha de nacimiento <span class="req">*</span></label>
            <input
              type="date"
              formControlName="birth_date"
              [max]="maxBirthDate"
              placeholder="Ingresa tu fecha de nacimiento"
            />
            <div
              *ngIf="
                form.get('birth_date')?.invalid &&
                form.get('birth_date')?.touched
              "
              class="sp-error-message"
            >
              <small *ngIf="form.get('birth_date')?.errors?.['required']">
                Campo requerido.
              </small>
            </div>
          </div>

          <div class="sp-field">
            <label>Edad <span class="req">*</span></label>
            <input
              type="number"
              formControlName="age"
              readonly
              placeholder="Ingresa tu fecha de nacimiento"
            />
          </div>

          <div
            class="sp-field"
            [ngClass]="{
              invalid:
                form.get('civil_status')?.invalid &&
                form.get('civil_status')?.touched,
              valid: form.get('civil_status')?.valid,
            }"
          >
            <label>Estado civil <span class="req">*</span></label>
            <select formControlName="civil_status">
              <option [ngValue]="null">Seleccione</option>
              <option value="SOLTERO">Soltero/a</option>
              <option value="CASADO">Casado/a</option>
              <option value="CONVIVIENTE">Conviviente</option>
              <option value="DIVORCIADO">Divorciado/a</option>
              <option value="VIUDO">Viudo/a</option>
            </select>
            <div
              *ngIf="
                form.get('civil_status')?.invalid &&
                form.get('civil_status')?.touched
              "
              class="sp-error-message"
            >
              <small *ngIf="form.get('civil_status')?.errors?.['required']">
                Campo requerido.
              </small>
            </div>
          </div>

          <div
            class="sp-field"
            [ngClass]="{
              invalid: isInvalid('blood_type'),
              valid: form.get('blood_type')?.valid,
            }"
          >
            <label>Tipo de sangre (Opcional) </label>
            <select formControlName="blood_type">
              <option [ngValue]="null">Seleccione</option>

              <option value="O+">O Rh positivo (O+)</option>
              <option value="O-">O Rh negativo (O-)</option>

              <option value="A+">A Rh positivo (A+)</option>
              <option value="A-">A Rh negativo (A-)</option>

              <option value="B+">B Rh positivo (B+)</option>
              <option value="B-">B Rh negativo (B-)</option>

              <option value="AB+">AB Rh positivo (AB+)</option>
              <option value="AB-">AB Rh negativo (AB-)</option>
              <option value="DESC">Desconozco</option>
            </select>
            <div class="sp-error-message" *ngIf="isInvalid('blood_type')">
              <small *ngIf="form.get('blood_type')?.errors?.['required']">
                Campo obligatorio
              </small>
            </div>
          </div>
        </div>
      </section>
      <section class="sp-step-panel" *ngIf="currentStep === 2">
        <h4 class="sp-section-title">Lugar de nacimiento</h4>

        <div class="sp-grid">
          <div
            class="sp-field"
            [ngClass]="{
              invalid: isInvalid('country'),
              valid: form.get('country')?.valid,
            }"
          >
            <label>País <span class="req">*</span></label>
            <select
              formControlName="country"
              (change)="onPaisTipoChange($event)"
            >
              <option [ngValue]="null">Seleccione</option>
              <option value="ECUADOR">ECUADOR</option>
              <option value="COLOMBIA">COLOMBIA</option>
              <option value="CHILE">CHILE</option>
              <option value="BOLIVIA">BOLIVIA</option>
              <option value="PERÚ">PERÚ</option>
              <option value="CANADÁ">CANADÁ</option>
              <option value="ESTADOS UNIDOS">ESTADOS UNIDOS</option>
              <option value="BRASIL">BRASIL</option>
              <option value="ARGENTINA">ARGENTINA</option>
              <option value="URUGUAY">URUGUAY</option>
              <option value="PARAGUAY">PARAGUAY</option>
              <option value="ESPAÑA">ESPAÑA</option>
              <option value="PORTUGAL">PORTUGAL</option>
              <option value="ALEMANIA">ALEMANIA</option>
              <option value="MÉXICO">MÉXICO</option>
              <option value="PANAMÁ">PANAMÁ</option>
              <option value="VENEZUELA">VENEZUELA</option>
            </select>
            <div class="sp-error-message" *ngIf="isInvalid('country')">
              <small>Campo obligatorio</small>
            </div>
          </div>

          <div
            class="sp-field"
            [ngClass]="{
              invalid: isInvalid('province'),
              valid: form.get('province')?.valid,
            }"
          >
            <label>Provincia <span class="req">*</span></label>

            <select
              formControlName="province"
              (change)="onProvinciaChange($event)"
              *ngIf="esEcuador"
            >
              <option [ngValue]="null">Seleccione</option>
              <option *ngFor="let p of provincias" [value]="p">
                {{ p }}
              </option>
            </select>

            <input
              type="text"
              formControlName="province"
              *ngIf="!esEcuador"
              placeholder="Ingrese la provincia"
              (input)="transformInput($event, 'province', true, true)"
            />

            <div class="sp-error-message" *ngIf="isInvalid('province')">
              <small>Campo obligatorio</small>
            </div>
          </div>

          <div
            class="sp-field"
            [ngClass]="{
              invalid: isInvalid('canton'),
              valid: form.get('canton')?.valid,
            }"
          >
            <label>Cantón <span class="req">*</span></label>

            <select
              formControlName="canton"
              (change)="onCantonChange($event)"
              *ngIf="esEcuador"
            >
              <option [ngValue]="null">Seleccione</option>
              <option *ngFor="let c of selectedCantones" [value]="c.nombre">
                {{ c.nombre }}
              </option>
            </select>

            <input
              type="text"
              formControlName="canton"
              *ngIf="!esEcuador"
              placeholder="Ingrese el cantón"
              (input)="transformInput($event, 'canton', true, true)"
            />

            <div class="sp-error-message" *ngIf="isInvalid('canton')">
              <small>Campo obligatorio</small>
            </div>
          </div>

          <div
            class="sp-field"
            [ngClass]="{
              invalid: isInvalid('village'),
              valid: form.get('village')?.valid,
            }"
          >
            <label>Parroquia <span class="req">*</span></label>

            <select formControlName="village" *ngIf="esEcuador">
              <option [ngValue]="null">Seleccione</option>
              <option *ngFor="let p of selectedParroquias" [value]="p">
                {{ p }}
              </option>
            </select>

            <input
              type="text"
              formControlName="village"
              *ngIf="!esEcuador"
              placeholder="Ingrese la parroquia"
              (input)="transformInput($event, 'village', true, true)"
            />

            <div class="sp-error-message" *ngIf="isInvalid('village')">
              <small>Campo obligatorio</small>
            </div>
          </div>
        </div>
      </section>
      <section class="sp-step-panel" *ngIf="currentStep === 3">
        <h4 class="sp-section-title">Contacto y domicilio actual</h4>

        <div class="sp-grid">
          <div
            class="sp-field"
            [ngClass]="{
              invalid: form.get('email')?.invalid && form.get('email')?.touched,
              valid: form.get('email')?.valid,
            }"
          >
            <label>📧 Correo electrónico <span class="req">*</span></label>
            <input
              type="email"
              formControlName="email"
              placeholder="Escribe tu correo electrónico"
              (input)="transformInput($event, 'email', false, false)"
            />
            <div
              *ngIf="form.get('email')?.invalid && form.get('email')?.touched"
              class="sp-error-message"
            >
              <small *ngIf="form.get('email')?.errors?.['required']">
                Campo requerido.
              </small>
              <small *ngIf="form.get('email')?.errors?.['email']">
                El correo electrónico no tiene un formato válido.
              </small>
            </div>
          </div>

          <div
            class="sp-field"
            [ngClass]="{
              invalid: form.get('phone')?.invalid && form.get('phone')?.touched,
              valid: form.get('phone')?.valid,
            }"
          >
            <label>📞 Teléfono de contacto <span class="req">*</span></label>
            <input
              type="text"
              inputmode="numeric"
              formControlName="phone"
              placeholder="Ingresa un teléfono de contacto"
              (input)="limitInteger($event, 'phone', 10)"
            />
            <div
              *ngIf="form.get('phone')?.invalid && form.get('phone')?.touched"
              class="sp-error-message"
            >
              <small *ngIf="form.get('phone')?.errors?.['required']">
                Campo requerido.
              </small>
            </div>
          </div>

          <div
            class="sp-field"
            [ngClass]="{
              invalid: isInvalid('city'),
              valid: form.get('city')?.valid,
            }"
          >
            <label>Ciudad <span class="req">*</span></label>
            <input
              type="text"
              formControlName="city"
              placeholder="Ingrese la ciudad"
              (input)="transformInput($event, 'city', true, true)"
            />
            <div class="sp-error-message" *ngIf="isInvalid('city')">
              <small>Campo obligatorio</small>
            </div>
          </div>

          <div
            class="sp-field"
            [ngClass]="{
              invalid: isInvalid('street'),
              valid: form.get('street')?.valid,
            }"
          >
            <label
              >Calle principal y secundaria (Opcional)</label
            >
            <textarea
              rows="1"
              formControlName="street"
              style="resize: none"
              placeholder="(Opcional) - Ingrese calle principal y secundaria"
              (input)="transformInput($event, 'street', true, true)"
            ></textarea>
          </div>
        </div>

        <div
          class="sp-field"
          [ngClass]="{
            valid: form.get('hood')?.valid,
          }"
        >
          <label>Referencia / Barrio (Opcional)</label>
          <textarea
            rows="2"
            formControlName="hood"
            style="resize: none"
            placeholder="(Opcional) - Ingrese una referencia de ubicación"
            (input)="transformInput($event, 'hood', true, true)"
          ></textarea>
        </div>
      </section>
      <section class="sp-step-panel" *ngIf="currentStep === 4">
        <h4 class="sp-section-title">Perfil profesional</h4>

        <div
          class="sp-field"
          [ngClass]="{
            invalid:
              form.get('vocation')?.invalid && form.get('vocation')?.touched,
            valid: form.get('vocation')?.valid,
          }"
        >
          <label>💼 Vocación profesional <span class="req">*</span></label>
          <input
            type="text"
            formControlName="vocation"
            maxlength="100"
            placeholder="Escribe tu vocación"
            (input)="transformInput($event, 'vocation', true, true)"
          />
          <div
            *ngIf="
              form.get('vocation')?.invalid && form.get('vocation')?.touched
            "
            class="sp-error-message"
          >
            <small *ngIf="form.get('vocation')?.errors?.['required']">
              Campo requerido.
            </small>
          </div>
        </div>

        <div
          class="sp-field"
          [ngClass]="{
            invalid:
              form.get('work_experience')?.invalid &&
              form.get('work_experience')?.touched,
            valid: form.get('work_experience')?.valid,
          }"
        >
          <label>🛠️ Experiencia laboral <span class="req">*</span></label>
          <textarea
            rows="4"
            maxlength="255"
            formControlName="work_experience"
            style="resize: none"
            placeholder="Cuéntanos acerca de tu experiencia laboral (Institución, tiempo, función)"
            (input)="transformInput($event, 'work_experience', true, true)"
          ></textarea>
          <div
            *ngIf="
              form.get('work_experience')?.invalid &&
              form.get('work_experience')?.touched
            "
            class="sp-error-message"
          >
            <small *ngIf="form.get('work_experience')?.errors?.['required']">
              Campo requerido.
            </small>
          </div>
        </div>

        <div
          class="sp-field"
          style="margin-top: 0.5rem"
          [ngClass]="{
            invalid: form.get('cv')?.invalid && form.get('cv')?.touched,
          }"
        >
          <label
            >Hoja de vida + certificado de capacitaciones + experiencia laboral
            cargado (un solo PDF) <span class="req">*</span></label
          >

          <div
            class="sp-file"
            [class.sp-file--dragover]="isDraggingCv"
            [class.sp-file--disabled]="!canUseRecruitmentForm || enviando"
            (dragenter)="onCvDragEnter($event)"
            (dragover)="onCvDragOver($event)"
            (dragleave)="onCvDragLeave($event)"
            (drop)="onCvDrop($event)"
          >
            <button
              type="button"
              (click)="fileInput.click()"
              [disabled]="!canUseRecruitmentForm || enviando"
            >
              Elegir archivo
            </button>

            <div class="sp-file-info">
              <strong>{{
                cvNombre || "Arrastra tu PDF aquí o selecciona un archivo"
              }}</strong>
              <small>Formato permitido: PDF. Tamaño máximo: 20 MB.</small>
            </div>

            <input
              #fileInput
              type="file"
              accept="application/pdf,.pdf"
              hidden
              (change)="onFileChange($event)"
            />
          </div>

          <div
            *ngIf="form.get('cv')?.invalid && form.get('cv')?.touched"
            class="sp-error-message"
          >
            <small *ngIf="form.get('cv')?.errors?.['required']">
              Campo requerido.
            </small>
          </div>
        </div>
      </section>
      <section class="sp-step-panel" *ngIf="currentStep === 5">
        <h4 class="sp-section-title">Revisión final</h4>

        <div class="sp-review-grid">
          <div><strong>Cédula:</strong> {{ form.get("id_card")?.value }}</div>
          <div><strong>Nombres:</strong> {{ form.get("name")?.value }}</div>
          <div>
            <strong>Apellido paterno:</strong>
            {{ form.get("father_surname")?.value }}
          </div>
          <div>
            <strong>Apellido materno:</strong>
            {{ form.get("mother_surname")?.value }}
          </div>
          <div>
            <strong>Fecha de nacimiento:</strong>
            {{ form.get("birth_date")?.value }}
          </div>
          <div><strong>Edad:</strong> {{ form.get("age")?.value }}</div>
          <div>
            <strong>Estado civil:</strong>
            {{ form.get("civil_status")?.value }}
          </div>
          <div>
            <strong>Tipo de sangre:</strong>
            {{ form.get("blood_type")?.value }}
          </div>
          <div><strong>País:</strong> {{ form.get("country")?.value }}</div>
          <div>
            <strong>Provincia:</strong> {{ form.get("province")?.value }}
          </div>
          <div><strong>Cantón:</strong> {{ form.get("canton")?.value }}</div>
          <div>
            <strong>Parroquia:</strong> {{ form.get("village")?.value }}
          </div>
          <div><strong>Correo:</strong> {{ form.get("email")?.value }}</div>
          <div><strong>Teléfono:</strong> {{ form.get("phone")?.value }}</div>
          <div><strong>Ciudad:</strong> {{ form.get("city")?.value }}</div>
          <div><strong>Calle:</strong> {{ form.get("street")?.value || 'N/A' }}</div>
          <div><strong>Referencia:</strong> {{ form.get("hood")?.value || 'N/A' }}</div>
          <div>
            <strong>Vocación:</strong> {{ form.get("vocation")?.value }}
          </div>
          <div class="sp-review-full">
            <strong>Experiencia laboral:</strong>
            {{ form.get("work_experience")?.value }}
          </div>
          <div class="sp-review-full">
            <strong
              >Hoja de vida + certificado de capacitaciones + experiencia
              laboral cargado:</strong
            >
            <ng-container *ngIf="form.get('cv')?.value; else noFile">
              <div class="sp-review-file">
                <span>{{ cvNombre }}</span>

                <button
                  type="button"
                  class="sp-link-btn"
                  (click)="descargarCV()"
                >
                  Descargar
                </button>
              </div>
            </ng-container>

            <ng-template #noFile>
              <span class="sp-muted">No adjuntado</span>
            </ng-template>
          </div>
        </div>
      </section>

      <div class="sp-actions">
        <button
          type="button"
          class="sp-btn-secondary"
          (click)="prevStep()"
          *ngIf="currentStep > 0"
          [disabled]="!canUseRecruitmentForm"
        >
          Anterior
        </button>

        <button
          type="button"
          class="sp-btn"
          (click)="nextStep()"
          *ngIf="currentStep < steps.length - 1"
          [disabled]="!canUseRecruitmentForm"
        >
          Siguiente
        </button>

        <button
          class="sp-btn"
          type="submit"
          [disabled]="!canUseRecruitmentForm || form.invalid || enviando"
          *ngIf="currentStep === steps.length - 1"
        >
          {{ enviando ? "Enviando..." : "Enviar postulación" }}
        </button>
      </div>
    </form>
  </div>
</div>
<div
  class="sp-policy-modal-backdrop"
  *ngIf="privacyModalOpen"
  (click)="closePrivacyPolicyDocument()"
>
  <section
    class="sp-policy-modal"
    role="dialog"
    aria-modal="true"
    aria-label="Tratamiento de datos personales"
    (click)="$event.stopPropagation()"
  >
    <header class="sp-policy-modal__header">
      <div>
        <span>DOCUMENTO LEGAL</span>
        <h3>{{ privacyPolicy?.title || "Tratamiento de datos personales" }}</h3>
        <small>
          {{ privacyPolicy?.original_file_name || "Documento PDF" }}
        </small>
      </div>

      <button
        type="button"
        class="sp-policy-modal__close"
        (click)="closePrivacyPolicyDocument()"
        title="Cerrar"
      >
        Cerrar
      </button>
    </header>

    <div class="sp-policy-modal__body">
      <div class="sp-policy-modal__loading" *ngIf="privacyPdfLoading">
        <div class="sp-policy-loader"></div>
        <span>Cargando documento...</span>
      </div>

      <iframe
        *ngIf="privacyPdfSafeUrl"
        class="sp-policy-frame"
        [src]="privacyPdfSafeUrl"
        title="Tratamiento de datos personales"
        (load)="onPrivacyPdfLoaded()"
      ></iframe>
    </div>
  </section>
</div>
